import { BASE_URL } from "./base_url";

export async function getCasebookLatestOne() {
  const response = await fetch(`${BASE_URL}/casebook/one`);

  // response 응답 체크 후 에러 발생로직
  if (!response.ok) {
    throw new Error("casebook 정보를 불러오는데 실패했습니다.");
  }
  const body = await response.json();
  // console.log(body);
  return body;
}

export const getCasebookByCustomUrl = async (customUrl) => {
  const response = await fetch(`${BASE_URL}/casebook/custom/${customUrl}`);
  const data = await response.json();
  return data;
};

export const getCaseBooksAll = async () => {
  const response = await fetch(`${BASE_URL}/casebook/getallcasebooks`);
  const data = await response.json();
  return data;
};

export const getCaseBookDetail = async (id) => {
  const response = await fetch(`${BASE_URL}/casebook/getonecasebook/${id}`);
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
  const result = await response.json();
  return result;
};
